import { useApi } from '@/api';
import {
  EntityName,
  IconKpiCard,
  KpiCard,
  Link,
  Page,
  PageSkeleton
} from '@/components';
import {
  CryptoIcon,
  Flex,
  Heading,
  LinkWrapper,
  NetworkIcon
} from '@blockanalitica/ui';
import HistoricTabs from './HistoricTabs';
export default function UnichainPage() {
  const [data, error] = useApi({
    url: '/unichain/'
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <EntityName symbol1={<NetworkIcon name="unichain" size="5" />}>
            <Heading size="1">
              <Flex gap="xs">Unichain</Flex>
            </Heading>
          </EntityName>
        }>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <IconKpiCard
            leftIcon={
              <EntityName
                symbol1={<CryptoIcon name={'USDS'} size="3" />}
                symbol2={<CryptoIcon name={'sUSDS'} size="3" />}>
                <></>
              </EntityName>
            }
            title="Total Circulating Assets"
            data={data}
            field="circulating_supply"
            options={{
              currencyValueOptions: { currency: 'USD' },
              linkArrow: false
            }}
          />
        </Flex>

        <HistoricTabs />
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <LinkWrapper
            to="/tokens/unichain/0x7e10036acc4b56d4dfca3b77810356ce52313f9c"
            // @ts-ignore
            as={Link}
            variant="kpiCardLinkWithBlendMode">
            <KpiCard
              variant="usds"
              title="USDS circulating supply"
              field="usds_circulating_supply"
              data={data}
              options={{
                currency: 'USD',
                linkArrow: true
              }}
            />
          </LinkWrapper>
          <LinkWrapper
            to="/tokens/unichain/0xa06b10db9f390990364a3984c04fadf1c13691b5"
            // @ts-ignore
            as={Link}
            variant="kpiCardLinkWithBlendMode">
            <KpiCard
              variant="susds"
              title="sUSDS circulating supply"
              field="susds_circulating_supply"
              data={data}
              options={{
                currency: 'USD',
                linkArrow: true
              }}
            />
          </LinkWrapper>
        </Flex>
      </Page>
    );
  }
  return <PageSkeleton />;
}
